import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Nav from './components/ui/Nav'
import Character from './pages/Characters'
import Gallery from './pages/Gallery'
import Products from './pages/Products'
import Story from './pages/Story'
import System from './pages/System'
import Arts from './pages/system/Arts'
import ATBattles from './pages/system/ATBattles'
import Crafts from './pages/system/Crafts'
import Minigames from './pages/system/Minigames'
import Shops from './pages/system/Shops'
import Support from './pages/system/Support'
import Top from './pages/Top'
import World from './pages/World'
import GA from './components/utility/GA'
import Footer from './Footer'
import './styles/app.scss'
import Contest from './pages/Contest'
import CharacterPoll from './pages/contest/CharacterPoll'
import ScrollToTop from './components/utility/ScrollToTop'
import FanArt from './pages/FanArt'
import FieldNotes from './pages/FieldNotes'
import Trailers from './pages/media/Trailers'
import Wallpapers from './pages/media/Wallpapers'
import RCC from './pages/contest/RCC'
import { useEffect, useState } from 'react'

function App() {
    const RELEASE_DATE_PT = new Date('2026-09-10T06:00:00-07:00').getTime()

    const [currentTime, setCurrentTime] = useState(Date.now())

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(Date.now())
        }, 10_000)

        return () => clearInterval(interval)
    }, [])

    const isReleased = currentTime >= RELEASE_DATE_PT
    return (
        <div className='App'>
            <Router basename={process.env.PUBLIC_URL}>
                <ScrollToTop>
                    <GA />
                    <Nav />
                    <Routes>
                        <Route exact path='/' element={<Top isReleased={isReleased} />} />
                        <Route path='story' element={<Story />} />
                        <Route path='character' element={<Character />} />
                        <Route path='field-notes' element={<FieldNotes />} />
                        <Route path='world' element={<World />} />
                        <Route path='system' element={<System />} />
                        <Route path='system/at-battle' element={<ATBattles />} />
                        <Route path='system/arts' element={<Arts />} />
                        <Route path='system/crafts' element={<Crafts />} />
                        <Route path='system/support-requests' element={<Support />} />
                        <Route path='system/minigames-extra' element={<Minigames />} />
                        <Route path='system/special-shops' element={<Shops />} />
                        <Route path='/products' element={<Products />} />
                        <Route path='/Gallery' element={<Gallery />}>
                            <Route index element={<Trailers />} />
                            <Route path='trailers' element={<Trailers />} />
                            <Route path='wallpapers' element={<Wallpapers />} />
                        </Route>
                        <Route path='/contest' element={<Contest />} />
                        <Route path='/contests' element={<RCC />} />
                        <Route path='/fanart' element={<FanArt />} />
                    </Routes>
                    <div className='portal-container'>
                        <a href='https://thelegendofheroes.com/' target='_blank' rel='noopener noreferrer'>
                            <button className='legends'>The Legend of Heroes - PORTAL SITE</button>
                        </a>
                        <a href='https://thelegendofheroes.com/crossbell/' target='_blank' rel='noopener noreferrer'>
                            <button className='crossbell'>Crossbell - PORTAL SITE</button>
                        </a>
                    </div>
                    <div className='spec-container'>
                        <table class='spec-table'>
                            <tbody>
                                <tr>
                                    <th>Title:</th>
                                    <td>The&nbsp;Legend&nbsp;of&nbsp;Heroes:&nbsp;Trails&nbsp;from&nbsp;Zero</td>
                                </tr>
                                <tr>
                                    <th>Release:</th>
                                    <td>
                                        September 10 (Nintendo Switch™2 and PlayStation®5)
                                        <br />
                                        Available now (Nintendo Switch™, PlayStation®4, and PC)
                                    </td>
                                </tr>
                                <tr>
                                    <th>Platform:</th>
                                    <td>Nintendo Switch™, PlayStation®4, PC</td>
                                </tr>
                                <tr>
                                    <th>Player(s:</th>
                                    <td>1</td>
                                </tr>
                                <tr>
                                    <th>Genre:</th>
                                    <td>RPG</td>
                                </tr>
                                <tr>
                                    <th>Audio:</th>
                                    <td>Japanese</td>
                                </tr>
                                <tr>
                                    <th>Text:</th>
                                    <td>English</td>
                                </tr>
                                <tr>
                                    <th>Developer:</th>
                                    <td>Nihon Falcom</td>
                                </tr>
                                <tr>
                                    <th>Publisher:</th>
                                    <td>NIS America, Inc.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <Footer />
                </ScrollToTop>
            </Router>
        </div>
    )
}

export default App
